import QmDatePicker from './src/picker/date-picker'

/* istanbul ignore next */
QmDatePicker.install = function (Vue) {
  Vue.component(QmDatePicker.name, QmDatePicker)
}

export default QmDatePicker
